var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "feet" },
        [
          _c(
            "el-button",
            {
              attrs: { size: "small", type: "primary" },
              on: {
                click: function ($event) {
                  return _vm.downloadFile(1)
                },
              },
            },
            [
              _vm._v(
                " " + _vm._s(_vm.$t("basicData.DownloadTheTemplate")) + " "
              ),
            ]
          ),
          _c("upload-excel", {
            staticClass: "feet-btn",
            attrs: {
              "but-name": _vm.BulkImport,
              "on-success": _vm.importLogistics,
            },
          }),
          _vm.importType === 1
            ? _c(
                "div",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small", type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.downloadFile(2)
                        },
                      },
                    },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.$t("basicData.DownloadTheQuote")) + " "
                      ),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.importType === 2
            ? _c(
                "div",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small", type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.downloadFile(3)
                        },
                      },
                    },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.$t("basicData.DownloadTheQuote")) + " "
                      ),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "append-to-body": true,
            title: _vm.$t("basicData.tips"),
            visible: _vm.dialogVisible,
            width: "400",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _vm._l(_vm.errData, function (item, ind) {
            return _c(
              "div",
              {
                key: ind,
                staticStyle: { color: "#f00", "margin-bottom": "8px" },
              },
              [_vm._v(_vm._s(item))]
            )
          }),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("basicData.determine")))]
              ),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }